<template>
    <v-menu ref="menu"
            v-model="shown"
            :close-on-content-click="false"
            transition="scale-transition"
            @update:return-value="saveDate"
            offset-y>
        <template v-slot:activator="{ on }">
            <v-text-field
                    :class="{'error' : !isValid}"
                    v-model="computedDateFormatted"
                    readonly
                    v-on="on"
            ></v-text-field>
        </template>
        <!-- @input="$refs.menu.save(date)" -->
        <v-date-picker
                class="date-picker"
                color="lightBlue"
                v-model="date"
                @input=""
                no-title scrollable>
            <TimePicker
                    v-model="time"
                    v-on:dateChanged="updateDate($event)"
                    :initialTime="initialTime"
                    slot="default">
            </TimePicker>
        </v-date-picker>
    </v-menu>
</template>
<script>
    import moment from 'moment';
    import TimePicker from "./TimePicker";

    export default {
        name: "DateTimePicker",
        components: {TimePicker},
        props: ['value', 'initialDate', 'isValid'],
        data: () => ({
            shown: false,
            date: null,
            initialTime: null,
            offset: 0,
            time: ''
        }),
        methods: {
            formatDate(date, time) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${day}/${month}/${year} ${time || this.time}`
            },
            updateDate($e) {
                const date = moment(this.date).add(this.offset, 'minutes');
                this.date = date.add($e, 'days').toISOString().substr(0, 10)
            },
            saveDate() {
              console.log("Saving date");
              this.$emit('input', this.formatDate(this.date, this.time));
            }
        },
        computed: {
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
        mounted() {
            this.date = this.initialDate.substr(0, 10) || null;
            this.offset = moment(this.initialDate).utcOffset();
            this.initialTime = moment(this.initialDate).toString().substr(16, 5) || null;
            this.time = this.initialTime || null
        },
        /* watch: {
            date: {
                handler: function (val) {
                    if (val) {
                        this.$emit('input', this.formatDate(val, this.time))
                    }
                },
                deep: true
            },
            time: {
                handler: function (val) {
                    if (val) {
                        this.$emit('input', this.formatDate(this.date, val))
                    }
                },
                deep: true
            }
        } */
    }
</script>

<style scoped>

</style>
